.mark {
  display: block;
  width: 30px;
  height: 30px;
  border: 2px solid var(--color-ink);
  object-fit: cover;
}
